export default __webpack_public_path__ + "static/media/processing_icon.7a22401f.svg";